import { Id } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, projectId: Id) {
  return getState().find((res) => res.project.uuid === projectId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveProjectReportsRequestFailure({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isFailure, false);
    },
    isRetrieveProjectReportsRequestPending({ uuid }) {
      return queryState(getState, uuid)((res) => res.request.isPending, false);
    },
    isRetrieveProjectReportsRequestSuccess({ uuid }) {
      return queryState(getState, uuid)(
        (res) => res.request.isSuccessful,
        false,
      );
    },
    getProjectReports({ uuid }) {
      return queryState(getState, uuid)((res) => res.reports, []);
    },
  };
}

export { createSelector };
